import React, { FC, useMemo } from "react";

import Grid from "../../Unknown/Grid";
import useCenterServiceOptions from "../AppointmentModifyServicesDialogContainer/useCenterServiceOptions";
import { CenterConfig } from "../AppointmentModifyServicesDialogContainer/types";
import useModifyServicesTranslations from "../AppointmentModifyServicesDialogContainer/translations";
import SelectCenterServiceInput, {
  Groups,
} from "../AppointmentModifyServicesDialogContainer/input";
import SelectStudyAddOnsForm from "../AppointmentModifyServicesDialogContainer/studyAddOnsForm";

interface ReadOnlyServicesProps {
  isSubmitting: boolean;
  centerConfig: CenterConfig;
  optionsProps: ReturnType<typeof useCenterServiceOptions>;
}

/**
 * Offerings/packages of the appointment shown as disabled selectors, with
 * their study-level add-ons editable (STAT ones locked).
 */
const ReadOnlyServices: FC<ReadOnlyServicesProps> = ({
  isSubmitting,
  centerConfig,
  optionsProps,
}) => {
  const { translations } = useModifyServicesTranslations();

  const groups: Groups = useMemo(
    () => ({
      package: translations.packagesTitle,
      "single-offering": translations.singleOfferingsTitle,
    }),
    [translations],
  );

  return (
    <Grid container spacing={3}>
      {optionsProps.selectedOptions.map((selectedOption) => (
        <Grid
          key={selectedOption?.localId ?? selectedOption?.value}
          item
          xs={12}
        >
          <SelectCenterServiceInput
            inputLabel={translations.selectScan}
            options={optionsProps.options}
            groups={groups}
            isDiscountShown={false}
            selectedOption={selectedOption}
            onChange={() => undefined}
            isLoading={false}
            isDisabled
          />
          {selectedOption?.value && (
            <SelectStudyAddOnsForm
              currentServiceId={selectedOption.localId}
              centerConfig={centerConfig}
              addOns={optionsProps.addOns}
              isSubmitting={isSubmitting}
              isStatLocked
              selectedCenterServices={optionsProps.selectedCenterServices}
              setSelectedCenterServices={optionsProps.setSelectedCenterServices}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default ReadOnlyServices;
